import KeyFigureRow from "./KeyFigureRow.js";

/**
 * Preliminary result rows are similar to keyFigure rows, except that:
 *
 * - They behave like account rows WRT their visibility;
 * - Unlike all others rows, 0 values are treated as no value (null).
 */
export default class PreliminaryResultRow extends KeyFigureRow {
	getTitle() {
		// override super implementation
		return this._title;
	}

	isVisibleWhenHidingAccounts() {
		return false;
	}

	canBeSelected() {
		return false;
	}

	/**
	 * Treat 0 as no value (null).
	 */
	hasData() {
		const data = this._report.getDataForRow(this);
		return data.some((datum) => datum && datum !== 0);
	}

	accept(visitor) {
		return visitor.visitPreliminaryResultRow(this);
	}
}
